'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../utils/functional');

var _listeners = require('../utils/listeners');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var MODULE_NAME = 'js-ThemeToggle';
var IS_BH = window.theme.isBHPreview;
// hardcoding URL values for now as we only need this for one store
var SITE_URL = 'https://www.ava-may.de/?_ab=0&_fd=0&_sc=1&preview_theme_id';
var PREVIEW_URL = 'https://www.ava-may.de/?_ab=0&_fd=0&_sc=1&preview_theme_id=122557890695';

var classes = {
  hide: 'util-Hide'
};

var cookies = {
  themeToggle: 'bh-theme-test',
  hideTooltip: 'bh-toggle-hide-tooltip'
};

var ThemeToggle = function () {
  function ThemeToggle(el) {
    (0, _classCallCheck3.default)(this, ThemeToggle);

    this.el = el;
    this.els = this.getEls();
    this.init();
  }

  (0, _createClass3.default)(ThemeToggle, [{
    key: 'init',
    value: function init() {
      this.listeners = new _listeners.Listeners();

      // if (Cookie.get(cookies.themeToggle) || IS_BH) {
      // this.el.classList.remove(classes.hide)
      // }

      if (IS_BH) {
        _jsCookie2.default.set(cookies.themeToggle, 'true', {
          expires: 90
        });
      }

      if (_jsCookie2.default.get(cookies.hideTooltip)) {
        this.els.tooltip.classList.add(classes.hide);
      } else {
        this.listeners.add(this.els.tooltipClose, 'click', this.hideTooltip.bind(this));
      }

      this.listeners.add(this.els.toggle, 'input', this.setActiveTheme.bind(this));
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      this.els.tooltip.classList.add(classes.hide);
      _jsCookie2.default.set(cookies.hideTooltip, 'true', {
        expires: 90
      });
    }
  }, {
    key: 'setActiveTheme',
    value: function setActiveTheme() {
      if (IS_BH) {
        window.location.href = SITE_URL;
        setTimeout(this.closeDrawer(), 1000);
      } else {
        window.location.href = PREVIEW_URL;
        setTimeout(this.closeDrawer(), 1000);
      }
    }
  }, {
    key: 'closeDrawer',
    value: function closeDrawer() {
      window.drawers.activeDrawerKey = '';
    }
  }, {
    key: 'getEls',
    value: function getEls() {
      var context = this.el;
      return {
        tooltip: (0, _functional.getElement)('.' + MODULE_NAME + '_Tooltip', { context: context }),
        tooltipClose: (0, _functional.getElement)('.' + MODULE_NAME + '_TooltipClose', { context: context }),
        toggle: (0, _functional.getElement)('.' + MODULE_NAME + '_Toggle', { context: context })
      };
    }
  }]);
  return ThemeToggle;
}();

var init = exports.init = function init(_ref) {
  var el = _ref.el;

  return new ThemeToggle(el);
};